/**
 * v6 fix: `NavLink` was imported from the broken v5-internal path
 * `react-router-dom/cjs/react-router-dom` — same issue as the last few
 * files, but here it's actually used (9 times), so this is a real fix, not
 * a deletion. Pointed at the real package export instead.
 *
 * Note: `className={styles.card}` (a plain string) still works fine on v6's
 * NavLink — v6 added an optional function form (`({isActive}) => ...`) for
 * className, it didn't remove plain-string support, so no further change
 * needed there.
 *
 * Separately, NOT a v6 issue but worth flagging: the "Affiliate Coupons"
 * card links to `/admin/affiliate-coupon-viewer`, which isn't registered as
 * a route anywhere in App.js (AffiliateCouponViewer is imported there but
 * never mounted to a <Route>). That gap predates this migration — this
 * card would have 404'd under v5 too — so it's flagged here rather than
 * silently "fixed" by guessing at a route path on your behalf.
 */
import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import CSSModule from 'react-css-modules';
import { injectIntl } from 'react-intl';

import { AppWrapper } from 'components';
import AuthProtected from 'containers/AuthProtected/AuthProtected';
import { actions as couponActions } from 'coupon-common/src/modules/coupons';

import styles from './AdminPanel.module.scss';

const AdminPanel = ({ dispatch, affiliateCoupons }) => {

    useEffect(() => {
        const action = couponActions.fetchAllAffiliateCoupons();
        dispatch(action);
    }, []);

    useEffect(() => {
     
        if (!affiliateCoupons) {
            console.warn('[AdminPanel] affiliateCoupons is null/undefined - is it in the reducer?');
            return;
        }

        const { fetching, fetched, byBusiness } = affiliateCoupons;


        const businesses = Object.entries(byBusiness || {});
        const loadedBusinesses = businesses.filter(([, b]) => b.fetched);
        const totalCoupons = loadedBusinesses.reduce(
            (sum, [, b]) => sum + ((b.data && b.data.results && b.data.results.length) || (b.data && b.data.length) || 0),
            0
        );

    }, [affiliateCoupons]);


    return (
        <div>
            <AppWrapper
                showHeader
                showSideNav
                showHeadingRow
                headingText={'Admin Panel'}
            >
                <AuthProtected />

                <div className={styles.container}>
                    <div className={styles.cardGrid}>
                        <NavLink to={'/admin/points'} className={styles.card}>
                            <img
                                src="https://icons.veryicon.com/png/o/business/business-style-icon/wallet-62.png"
                                alt="Points Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Points Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/users'} className={styles.card}>
                            <img
                                src="https://i.postimg.cc/CxjNdJRj/6481225432795d8cdf48f0f85800cf66-removebg-preview.png"
                                alt="User Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>User Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/blogs'} className={styles.card}>
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/2593/2593549.png"
                                alt="Blog Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Blog Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/authors'} className={styles.card}>
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                alt="Author Profiles Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Author Profiles</h5>
                        </NavLink>
                        <NavLink to={'/admin/affiliate-manager'} className={styles.card}>
                            <img
                                src="https://cdn3.iconfinder.com/data/icons/business-marketing-advertising-blue-and-red/64/Marketing_affiliate_marketing-512.png"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Affiliate Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/flyer-import'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Flyer Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/rakuten-import'} className={styles.card}>
                            <img
                                src="https://companieslogo.com/img/orig/4755.T-0488a1c7.png?t=1746035131"
                                alt="Points Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Rakuten Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/awin-import'} className={styles.card}>
                            <img
                                src="https://spng.pngfind.com/pngs/s/449-4495328_awin-logo-graphic-design-hd-png-download.png"
                                alt="Points Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Awin Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/cj-import'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="CJ Offer Fetcher"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>CJ Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/promo-manager'} className={styles.card}>
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/6165/6165581.png"
                                alt="Points Manager Icon"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Promo Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/cj-import'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="CJ Offer Fetcher"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>CJ Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/affiliate-coupon-viewer'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="Affiliate Coupon Viewer"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Affiliate Coupons</h5>
                        </NavLink>
                        <NavLink to={'/admin/impact-import'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="Impact Offer Fetcher"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Impact Import</h5>
                        </NavLink>
                        <NavLink to={'/admin/blog-manager'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="Blog Manager"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Blog Manager</h5>
                        </NavLink>
                        <NavLink to={'/admin/analytics'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="Data Viewer"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Analytics</h5>
                        </NavLink>
                        <NavLink to={'/admin/email-manager'} className={styles.card}>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-download-import-color-icon.png"
                                alt="Data Viewer"
                                className={styles.cardImage}
                            />
                            <h5 className={styles.cardTitle}>Email Manager</h5>
                        </NavLink>




                    </div>
                </div>
            </AppWrapper>
        </div>
    );
};

const mapStateToProps = (state) => {
    // console.log('[AdminPanel] mapStateToProps - full coupons state:', state.coupons);
    return {
        authorized: state.auth.authorized,
        data: state.pointsRequests.processPointsRequest.data,
        error: state.pointsRequests.processPointsRequest.error,
        pointsActivityIsModalOpen: state.pointsRequests.pointsActivity.isModalOpen,
        processPointsFetching: state.pointsRequests.processPointsRequest.fetching,
        affiliateCoupons: state.coupons.affiliateCoupons,
    };
};

export default connect(mapStateToProps)(injectIntl(CSSModule(AdminPanel, styles)));